export default __webpack_public_path__ + "static/media/soul-green.62d8e4a8.png";